/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StopSageIntacctRecipesInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type stopSageIntacctRecipesMutationVariables = {|
  input: StopSageIntacctRecipesInput
|};
export type stopSageIntacctRecipesMutationResponse = {|
  +stopSageIntacctRecipes: ?{|
    +outcome: ?string
  |}
|};
export type stopSageIntacctRecipesMutation = {|
  variables: stopSageIntacctRecipesMutationVariables,
  response: stopSageIntacctRecipesMutationResponse,
|};
*/


/*
mutation stopSageIntacctRecipesMutation(
  $input: StopSageIntacctRecipesInput!
) {
  stopSageIntacctRecipes(input: $input) {
    outcome
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "StopSageIntacctRecipesInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StopSageIntacctRecipesPayload",
    "kind": "LinkedField",
    "name": "stopSageIntacctRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stopSageIntacctRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stopSageIntacctRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "stopSageIntacctRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation stopSageIntacctRecipesMutation(\n  $input: StopSageIntacctRecipesInput!\n) {\n  stopSageIntacctRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4a8a118d2a4b9a099745b71b0fac618d';

module.exports = node;
